export const nataliaSarnowska = {
    'firstName': 'Natalia',
    'lastName': 'Sarnowska',
    'profession': 'Pedagog specjalny, psychoterapeuta dzieci i młodzieży',
    'avatar': 'natalia-sarnowska.webp',
    'slug': 'pedagog-psychoterapeuta-natalia-sarnowska',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychoterapy', 'parents'],
        ['psychoterapy', 'family'],
        ['group', 'socialSkills'],
        ['diagnosis', 'autism'],
    ]
}